import { ClassNames } from '@emotion/core'
import React from 'react'
import PropTypes from 'prop-types'

import { Text } from 'shared/components/text'

import * as styles from './styles'

const buildSkeletonNumbers = (count) =>
  Array.from({ length: count }, (_, index) => index + 1)

const SkeletonRows = ({ columnCount, rowCount }) => {
  const rowNumbers = buildSkeletonNumbers(rowCount)
  const columnNumbers = buildSkeletonNumbers(columnCount)

  return (
    <ClassNames>
      {({ css, cx }) =>
        rowNumbers.map((rowNumber) => (
          <div
            key={`skeleton-row-${rowNumber}`}
            className={css(styles.skeletonRow(columnCount))}
          >
            {columnNumbers.map((columnNumber) => (
              <div
                key={`skeleton-cell-${rowNumber}-${columnNumber}`}
                className={cx(
                  css(styles.skeletonCell),
                  columnNumber === 1 && css(styles.skeletonCellPrimary)
                )}
              />
            ))}
          </div>
        ))
      }
    </ClassNames>
  )
}

SkeletonRows.propTypes = {
  columnCount: PropTypes.number.isRequired,
  rowCount: PropTypes.number.isRequired,
}

const TableStateComponent = ({
  variant,
  title,
  description,
  columnCount,
  rowCount,
}) => {
  if (variant === 'loading') {
    return (
      <ClassNames>
        {({ css }) => (
          <div className={css(styles.skeletonWrapper)}>
            <SkeletonRows columnCount={columnCount} rowCount={rowCount} />
          </div>
        )}
      </ClassNames>
    )
  }

  return (
    <ClassNames>
      {({ css }) => (
        <div className={css(styles.stateWrapper)} data-variant={variant}>
          <Text size={16} bold>
            {title}
          </Text>
          {!!description && <Text size={13}>{description}</Text>}
        </div>
      )}
    </ClassNames>
  )
}

TableStateComponent.propTypes = {
  variant: PropTypes.oneOf(['loading', 'empty', 'error']).isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  columnCount: PropTypes.number,
  rowCount: PropTypes.number,
}

TableStateComponent.defaultProps = {
  title: '',
  description: '',
  columnCount: 5,
  rowCount: 6,
}

export default TableStateComponent
